import { modules } from '@veritone/glc-redux';

import { userPermissionsSagas } from '@user-permissions';

import appSaga from '../modules/app/sagas';
import { saga as engineAvailabilitySaga } from '../modules/engines/availability/saga';
import { saga as ingestionSaga } from '../modules/engines/ingestion/saga';
import { saga as opticalTrackingSaga } from '../modules/engines/optical-tracking/saga';
import { saga as transcriptionSaga } from '../modules/engines/transcription/saga';
import { saga as voiceMaskSaga } from '../modules/engines/voice-mask/saga';
import { saga as speakerSeparationSaga } from '../modules/engines/speaker-separation/saga';
import {
  watchCreateJobFacesData,
  watchCreateJobFacesSuccess,
  watchDeleteDetectionResults,
  // watchLoadFacesStatus,
  // watchReLoadFacesStatus,
} from '../modules/facesTabModule/saga';
import filePickerRootSaga from '@common-modules/filePicker/saga';
import keyboardSagas from '@redact-modules/keyboard/saga';
// import {
//   watchCreateJobLicensePlatesData,
//   watchLoadLicensePlatesStatus,
// } from '@redact-modules/licensePlatesTabModule/saga';
import { initMediaDetails } from '../modules/mediaDetails/saga';
import { initNotification } from '@common-modules/notification/saga';
// import metricsSagas from '@redact-modules/metrics';
import overviewSaga from '@redact-modules/overview/saga';
import routeSaga from '@common-modules/routing/sagas';
import { uploadsSaga } from '@redact-modules/uploads/sagas';
import trimSaga from '@common-modules/trim/saga';
import { initRedactFile } from '@common-modules/redactFile/saga';
import { videoReactSaga } from '@common-modules/player/saga';
import {
  documentBurnInSaga,
  documentsSaga,
  redactAllSaga,
} from '@redact-modules/documents/sagas';
import { statusHistorySaga } from '@common-modules/statusHistory';
import { watchCheckRootOrganization } from '@redact-modules/admin/sagas';
import { projectsSaga } from '@redact-modules/projects/sagas';
import { projectAuditSaga } from '@redact-modules/projects/auditEvents';
import { batchStatusWatchers } from '@redact-modules/casemedia/sagas';
import { combineProjectSaga } from '@redact-modules/projects/combineSaga';
import { watchEditorUrlState } from '@redact-modules/documents/sagas/editorUrlState';
const {
  auth: { authRootSaga },
} = modules;

// these are sagas that should run on *all* routes, at app startup.
// define route-specific sagas on the routesMap
export const sagas = [
  userPermissionsSagas,
  routeSaga,
  appSaga,
  authRootSaga,
  watchCreateJobFacesData,
  watchCreateJobFacesSuccess,
  watchDeleteDetectionResults,
  // watchLoadFacesStatus,
  // watchReLoadFacesStatus,
  // watchCreateJobLicensePlatesData,
  // watchLoadLicensePlatesStatus,
  overviewSaga,
  filePickerRootSaga,
  uploadsSaga,
  engineAvailabilitySaga,
  ingestionSaga,
  opticalTrackingSaga,
  transcriptionSaga,
  voiceMaskSaga,
  speakerSeparationSaga,
  initMediaDetails,
  keyboardSagas,
  // metricsSagas,
  trimSaga,
  initRedactFile,
  initNotification,
  videoReactSaga,
  documentsSaga,
  // setting up a request's merged document.
  projectsSaga,
  // The merged document's set-wide audit events (VE-31977). Its own entry for
  // the reason the three below have theirs: `projectsSaga` owns the sliding
  // membership channel and the Bates/watermark write queue, and a throw in an
  // audit watcher restarting that root would discard a write queue mid-write.
  // Two of its watchers are also combineProjectSaga's acts rather than
  // projectsSaga's, so a root of its own is the only placement that does not
  // pick the wrong owner for one of them.
  projectAuditSaga,
  // Its own entry, like documentBurnInSaga: a combine is a long sequence that
  // uploads a released artifact, and a throw in one of projectsSaga's siblings
  // must not restart that root and cancel it mid-upload.
  combineProjectSaga,
  watchEditorUrlState,
  statusHistorySaga,
  // App-wide rather than on the admin routes, because the SIDE NAV asks the
  // question now: the Admin entry only appears for the instance root org, and
  // the drawer is reachable from every page. It was a route saga, which meant
  // the one page that dispatched the check without having one got no answer
  // and rendered as though the check were still running.
  watchCheckRootOrganization,
  // Its own keepAlive entry on purpose: a detached document burn-in must not
  // be cancelled by a throw in one of documentsSaga's siblings (VE-28061).
  documentBurnInSaga,
  // And its own for the same reason, more so: a Redact All pass is a sequence
  // of those burn-ins (VE-31006), so it is the longest-running thing in the
  // app and has the most to lose from an unrelated sibling throwing halfway
  // through. Restarting it would not resume it — the list is held in memory
  // — it would simply stop, mid-release, with some files burned.
  redactAllSaga,
  // Its own entry for the same reason as the three above, and it earned it the
  // same way: a bulk redaction-status change is a sequential, audited,
  // non-transactional write over a whole release. It used to be a route
  // saga's, which meant an editor route cancelled it mid-loop on a document
  // switch — some files written, some not, and nothing said so. App startup is
  // the only lifetime that outlives everywhere it can be started from.
  batchStatusWatchers,
];
